import { render } from "./IFrameCookies.vue?vue&type=template&id=3a8ecc2c"
import script from "./IFrameCookies.vue?vue&type=script&lang=js"
export * from "./IFrameCookies.vue?vue&type=script&lang=js"

import "./IFrameCookies.vue?vue&type=style&index=0&id=3a8ecc2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__